import { withInstall, withNoopInstall } from '@zoryn/utils'
import Dashboard from './src/dashboard.vue'
import DashboardSection from './src/dashboard-section.vue'
import DashboardCard from './src/dashboard-card.vue'
import DashboardEmpty from './src/dashboard-empty.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZDashboard: SFCWithInstall<typeof Dashboard> & {
  DashboardSection: typeof DashboardSection
  DashboardCard: typeof DashboardCard
  DashboardEmpty: typeof DashboardEmpty
} = withInstall(Dashboard, {
  DashboardSection,
  DashboardCard,
  DashboardEmpty,
})

export default ZDashboard
export const ZDashboardSection: SFCWithInstall<typeof DashboardSection> =
  withNoopInstall(DashboardSection)
export const ZDashboardCard: SFCWithInstall<typeof DashboardCard> =
  withNoopInstall(DashboardCard)
export const ZDashboardEmpty: SFCWithInstall<typeof DashboardEmpty> =
  withNoopInstall(DashboardEmpty)

export * from './src/dashboard'
export type {
  DashboardInstance,
  DashboardSectionInstance,
  DashboardCardInstance,
  DashboardEmptyInstance,
} from './src/instance'
